module.exports = "<svg viewBox=\"118 12 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><polygon points=\"126 24 121.297718 26.472136 122.195774 21.236068 118.391548 17.527864 123.648859 16.763932 126 12 128.351141 16.763932 133.608452 17.527864 129.804226 21.236068 130.702282 26.472136\"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/star.svg
// module id = 323
// module chunks = 0 1